<template>
  <div>
    <el-form :model="form" :rules="rules" ref="form">
      <TopBarTitleComponent title="Nueva Guía de Remisión" :showBackIcon="true">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonPrimaryComponent title="Guardar" @onSaveClick="handleSave" />
          </div>
        </template>
      </TopBarTitleComponent>

      <b-container fluid class="pb-4 px-lg-4 pt-4">
        <b-row>
          <b-col>
            <div class="card box-shadow">
              <div class="card-body">
                <!-- ── Emisión ─────────────────────────────────────────── -->
                <h6 class="font-bold text-color-primary mb-3">
                  Punto de emisión
                </h6>
                <b-row>
                  <b-col xs="12" sm="12" md="4">
                    <el-form-item prop="user_business_e_point_id">
                      <SelectEmissionPointsComponent
                        title="Punto de emisión *"
                        @onChangeSelect="onChangeEmissionPoint"
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="4">
                    <InputDatePickerComponent
                      title="Fecha de emisión"
                      prop="emission_date"
                      :isDisabledDate="true"
                      :setDate="form.emission_date"
                      @onChangeDatePicker="
                        ({ date }) => (form.emission_date = date)
                      "
                    />
                  </b-col>
                </b-row>

                <!-- ── Transportista ──────────────────────────────────── -->
                <hr class="my-4" />
                <h6 class="font-bold text-color-primary mb-3">
                  Datos del Transportista
                </h6>
                <b-row>
                  <b-col xs="12" sm="12" md="6">
                    <el-form-item prop="carrier_name">
                      <SelectCarrierComponent
                        title="Transportista *"
                        @onChangeSelect="onChangeCarrier"
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item prop="carrier_ruc">
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Identificación
                          <span class="text-danger">*</span></label
                        ></slot
                      >
                      <el-input
                        v-model="form.carrier_ruc"
                        placeholder="RUC / Cédula / Placa"
                        disabled
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item prop="carrier_plate">
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Placa <span class="text-danger">*</span></label
                        ></slot
                      >
                      <el-input
                        v-model="form.carrier_plate"
                        placeholder="ABC-1234"
                      />
                    </el-form-item>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xs="12" sm="12" md="3">
                    <InputDatePickerComponent
                      title="Inicio de transporte"
                      prop="transport_start_date"
                      :setDate="form.transport_start_date"
                      @onChangeDatePicker="
                        ({ date }) => (form.transport_start_date = date)
                      "
                    />
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <InputDatePickerComponent
                      title="Fin de transporte"
                      prop="transport_end_date"
                      :setDate="form.transport_end_date"
                      @onChangeDatePicker="
                        ({ date }) => (form.transport_end_date = date)
                      "
                    />
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item>
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Dirección de partida</label
                        ></slot
                      >
                      <el-input
                        v-model="form.departure_address"
                        placeholder="Dirección de origen"
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item>
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Correo transportista</label
                        ></slot
                      >
                      <el-input
                        v-model="form.carrier_email"
                        placeholder="email@ejemplo.com"
                      />
                    </el-form-item>
                  </b-col>
                </b-row>

                <!-- ── Destinatario ────────────────────────────────────── -->
                <hr class="my-4" />
                <h6 class="font-bold text-color-primary mb-3">
                  Datos del Destinatario
                </h6>
                <b-row>
                  <b-col xs="12" sm="12" md="6">
                    <el-form-item prop="destination_name">
                      <SelectBusinessComponent
                        title="Destinatario *"
                        placeholder="Buscar destinatario"
                        @onChangeSelect="onChangeDestination"
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item prop="destination_id">
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Identificación
                          <span class="text-danger">*</span></label
                        ></slot
                      >
                      <el-input
                        v-model="form.destination_id"
                        placeholder="RUC / Cédula"
                        disabled
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item>
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Correo destinatario</label
                        ></slot
                      >
                      <el-input
                        v-model="form.email"
                        placeholder="email@ejemplo.com"
                      />
                    </el-form-item>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xs="12" sm="12" md="6">
                    <el-form-item prop="destination_address">
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Dirección del destinatario
                          <span class="text-danger">*</span></label
                        ></slot
                      >
                      <el-input
                        v-model="form.destination_address"
                        placeholder="Dirección de destino"
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="6">
                    <el-form-item>
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Ruta (opcional)</label
                        ></slot
                      >
                      <el-input
                        v-model="form.route"
                        placeholder="Ruta del recorrido"
                      />
                    </el-form-item>
                  </b-col>
                </b-row>

                <!-- ── Documento sustento ─────────────────────────────── -->
                <hr class="my-4" />
                <h6 class="font-bold text-color-primary mb-3">
                  Documento Sustento
                </h6>
                <b-row>
                  <b-col xs="12" sm="12" md="6">
                    <el-form-item>
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Buscar factura</label
                        ></slot
                      >
                      <el-autocomplete
                        v-model="invoiceSearch"
                        :fetch-suggestions="searchInvoices"
                        :trigger-on-focus="false"
                        placeholder="Buscar por número de factura"
                        suffix-icon="el-icon-search"
                        @select="onSelectInvoice"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <div class="d-flex justify-content-between">
                            <span>{{ item.number_invoice }}</span>
                            <small class="text-muted">{{
                              item.client ? item.client.name : ""
                            }}</small>
                          </div>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item>
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >N° autorización SRI</label
                        ></slot
                      >
                      <el-input
                        v-model="form.supporting_doc_auth"
                        placeholder="49 dígitos"
                        disabled
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <InputDatePickerComponent
                      title="Fecha doc. sustento"
                      prop="supporting_doc_date"
                      :setDate="form.supporting_doc_date"
                      :disabled="true"
                      @onChangeDatePicker="
                        ({ date }) => (form.supporting_doc_date = date)
                      "
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xs="12" sm="12" md="6">
                    <el-form-item prop="transfer_reason">
                      <slot name="label"
                        ><label class="font-semi-bold m-0"
                          >Motivo de traslado
                          <span class="text-danger">*</span></label
                        ></slot
                      >
                      <el-input
                        v-model="form.transfer_reason"
                        placeholder="Ej: Venta de mercadería"
                      />
                    </el-form-item>
                  </b-col>
                </b-row>

                <!-- ── Mercadería ─────────────────────────────────────── -->
                <hr class="my-4" />
                <h6 class="font-bold text-color-primary mb-3">
                  Mercadería a transportar
                </h6>
                <TableInputProducts
                  @onToogleProducts="onToogleProducts"
                  :setProducts="rawProducts"
                  :setEmissionPointId="form.user_business_e_point_id"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </el-form>
  </div>
</template>

<script>
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import InputDatePickerComponent from "../../../../components/InputDatePicker";
import SelectEmissionPointsComponent from "../../../../components/SelectEmissionPoints";
import SelectBusinessComponent from "../../../../components/SelectBusinessV2";
import SelectCarrierComponent from "../../../../components/SelectCarrier";
import TableInputProducts from "../../../components/TableInputProducts";
import remissionService from "../services/remissionService";
import invoiceService from "../../invoices/services/invoiceService";
import Validate from "@/assets/validate";
import moment from "moment";

const DATE_AT = moment().format("YYYY-MM-DD");

export default {
  name: "RemissionAddPage",
  components: {
    ButtonPrimaryComponent,
    TopBarTitleComponent,
    InputDatePickerComponent,
    SelectEmissionPointsComponent,
    SelectBusinessComponent,
    SelectCarrierComponent,
    TableInputProducts
  },
  data: () => ({
    invoiceSearch: "",
    invoiceResults: [],
    rawProducts: [],
    form: {
      user_business_e_point_id: null,
      emission_date: DATE_AT,
      email: "",
      carrier_email: "",
      carrier_ruc: "",
      carrier_document_type: "",
      carrier_name: "",
      carrier_plate: "",
      transport_start_date: DATE_AT,
      transport_end_date: DATE_AT,
      departure_address: "",
      destination_name: "",
      destination_id: "",
      destination_id_type: "05",
      destination_address: "",
      transfer_reason: "",
      route: "",
      supporting_doc_type: "01",
      supporting_doc_number: "",
      supporting_doc_auth: "",
      supporting_doc_date: "",
      items: []
    },
    rules: {
      user_business_e_point_id: [Validate.rules.required("change")],
      emission_date: [Validate.rules.required()],
      carrier_name: [Validate.rules.required()],
      carrier_plate: [Validate.rules.required()],
      carrier_ruc: [Validate.rules.required()],
      destination_name: [Validate.rules.required()],
      destination_id: [Validate.rules.required()],
      destination_address: [Validate.rules.required()],
      transfer_reason: [Validate.rules.required()]
    }
  }),
  methods: {
    onChangeEmissionPoint({ emissionPointId }) {
      this.form.user_business_e_point_id = emissionPointId;
    },

    // ── Transportista (desde directorio de transportistas) ─────────────
    mapDocumentType(docType) {
      const doc = (docType || "").toUpperCase();
      if (doc === "RUC" || doc === "04") return "04";
      if (doc === "CEDULA" || doc === "CÉDULA" || doc === "05") return "05";
      if (doc === "PASAPORTE" || doc === "06") return "06";
      // Detectar por longitud del documento
      return doc.length <= 2 ? doc : "05";
    },
    onChangeCarrier({ carrier }) {
      if (carrier) {
        this.form.carrier_name = carrier.name;
        this.form.carrier_ruc = carrier.document || "";
        this.form.carrier_document_type = this.mapDocumentType(
          carrier.document_type
        );
        this.form.carrier_plate = carrier.plate || "";
        this.form.carrier_email = carrier.email || "";
      }
    },

    // ── Destinatario (desde directorio) ───────────────────────────────
    onChangeDestination({ client }) {
      if (client) {
        this.form.destination_name = client.name;
        this.form.destination_id = client.document;
        this.form.destination_address = client.address || "";
        this.form.email = client.email || "";

        // Detectar tipo de documento
        const doc = client.document || "";
        if (doc.length === 13) {
          this.form.destination_id_type = "04"; // RUC
        } else if (doc.length === 10) {
          this.form.destination_id_type = "05"; // Cédula
        } else {
          this.form.destination_id_type = "06"; // Pasaporte
        }
      }
    },

    // ── Buscar facturas para doc sustento ──────────────────────────────
    async searchInvoices(queryString, cb) {
      if (queryString.length < 3) {
        cb([]);
        return;
      }
      try {
        const response = await invoiceService.getInvoices({
          params: {
            search: queryString,
            status: "success"
          }
        });
        const invoices = response.data.data
          ? response.data.data.data || response.data.data
          : [];
        cb(
          invoices.map(inv => ({
            ...inv,
            value: inv.number_invoice
          }))
        );
      } catch (e) {
        cb([]);
      }
    },

    onSelectInvoice(invoice) {
      this.form.supporting_doc_type = "01"; // Factura
      this.form.supporting_doc_number = invoice.number_invoice || "";
      this.form.supporting_doc_auth = invoice.access_key || "";
      this.form.supporting_doc_date = invoice.emission_date || "";
      this.invoiceSearch = invoice.number_invoice || "";
    },

    // ── Productos (misma tabla que facturas) ──────────────────────────
    onToogleProducts({ products }) {
      this.rawProducts = products;
    },

    // Convierte el HTML del editor de detalle a texto plano (para PDF/SRI).
    plainText(html) {
      if (!html) return "";
      return String(html)
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/(div|p|li)>/gi, "\n")
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/\n{3,}/g, "\n\n")
        .replace(/[ \t]+\n/g, "\n")
        .trim();
    },

    // Combina nombre del producto + detalle en un solo campo (como factura):
    // "Nombre\nDetalle". Si no hay detalle, solo el nombre.
    buildItemDescription(p) {
      const name = (p.name || "").trim();
      const detail = this.plainText(p.product_detail);
      return detail ? `${name}\n${detail}` : name;
    },

    handleSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.$store.dispatch("toggleRequestLoading");
        try {
          this.form.items = this.rawProducts.map(p => ({
            user_business_product_id: p.user_business_product_id || p.id,
            item_code: p.code || p.product_code || "",
            // Nombre del producto + detalle (como en factura/cotización), en un
            // solo campo. El nombre va primero y el detalle en la línea siguiente.
            item_description: this.buildItemDescription(p),
            quantity: p.product_quantity || 1
          }));
          const response = await remissionService
            .addRemission(this.form)
            .finally(() => this.$store.dispatch("toggleRequestLoading"));
          if (response.data.success) {
            this.$router.push({
              name: "sales.remissions.view",
              params: { id: response.data.data.id }
            });
          }
        } catch (e) {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.el-form .el-input__inner {
  color: #2d2b55 !important;
}
.el-form .el-input__inner::placeholder {
  color: #c0c4cc !important;
}
.el-form .el-input.is-disabled .el-input__inner {
  color: #909399 !important;
}
</style>
